import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavBar from '../components/common/TopNavBar';

// ─── HuPath v2 Design Tokens ──────────────────────────────────────────────
const HT = {
  yellow: '#FFD166', yellowSoft: '#FFE9A8', yellowBg: '#FFF8E7', yellowShadow: '#E0B554',
  green: '#88C057', greenDark: '#5E9E3E', greenSoft: '#D4E8C0', greenBg: '#E8F3D9', greenShield: '#C9E4A5',
  cream: '#FFF8E7',
  coral: '#FF8C42', coralDark: '#E76F51', coralPress: '#B8431E',
  pinkBg: '#FCE4E8', pink: '#F4A6B8',
  brown: '#8B6F47', brownDark: '#6B4F2B',
  text: '#2D2D2D', textSoft: '#6B6B6B', textMuted: '#9A9A9A',
  border: '#E8E0CC', white: '#FFFFFF', teal: '#5AC0B5',
  plum: '#5B2E5E', aqua: '#3DC9B5', accent: '#FFD23F',
};
const FONT_DISPLAY = '"Fredoka", "Baloo 2", "Nunito", sans-serif';
const FONT_BODY = '"Nunito", "Baloo 2", sans-serif';
const SHADOW_SM = '0 2px 6px rgba(139,111,71,0.08)';
const SHADOW_MD = '0 4px 16px rgba(139,111,71,0.10)';

const WeeklyReportPage = () => {
  const navigate = useNavigate();

  // Mock data — would come from API in production
  const stats = [
    { emoji: '✅', value: '12 bài', label: 'Hoàn thành', color: HT.teal, bg: '#E8F8F5' },
    { emoji: '⏱️', value: '45 phút', label: 'Luyện tập', color: HT.yellow, bg: HT.yellowBg },
    { emoji: '🏆', value: '+2 mới', label: 'Đã thuộc', color: HT.coral, bg: '#FFF0E6' },
    { emoji: '🔥', value: '5 ngày', label: 'Streak', color: HT.greenDark, bg: HT.greenBg },
  ];

  const strengths = [
    { name: 'Matching (Listening Part 3)', score: 95, msg: 'Kỹ năng phân tích từ khoá và nối thông tin rất xuất sắc!' },
    { name: 'Animals (Vocabulary)', score: 85, msg: 'Con nhớ rất tốt các từ vựng về động vật hoang dã.' },
    { name: 'Comparatives (Grammar)', score: 90, msg: 'Sử dụng thành thạo cấu trúc so sánh hơn với tính từ ngắn.' },
  ];

  const weaknesses = [
    { name: 'Past Simple', score: 35, tip: 'Cùng con đọc truyện ngắn tiếng Anh, chú ý động từ quá khứ.' },
    { name: 'Food & Drink', score: 40, tip: 'Khi đi siêu thị, chỉ vào đồ ăn và hỏi con tiếng Anh.' },
    { name: 'Prepositions', score: 45, tip: 'Chơi trò đặt đồ vật: Put the book ON the table.' },
  ];

  const progress = [
    { label: 'Kỹ năng Nghe', prev: '65%', current: '72%', diff: '+7%', positive: true },
    { label: 'Kỹ năng Đọc & Viết', prev: '58%', current: '58%', diff: '0%', positive: false },
    { label: 'Tổng bài làm', prev: '8', current: '12', diff: '+4', positive: true },
  ];

  const weekDays = [
    { day: 'T2', active: true, count: '3 bài', time: '15′' },
    { day: 'T3', active: true, count: '2 bài', time: '10′' },
    { day: 'T4', active: false },
    { day: 'T5', active: true, count: '4 bài', time: '20′' },
    { day: 'T6', active: true, count: '2 bài', time: '10′' },
    { day: 'T7', active: true, count: '3 bài', time: '15′' },
    { day: 'CN', active: false },
  ];

  return (
    <div style={{ minHeight: '100vh', background: HT.yellowBg, fontFamily: FONT_BODY, color: HT.text, display: 'flex', flexDirection: 'column' }}>
      <TopNavBar />

      <main style={{ padding: '28px 24px 60px', maxWidth: 1200, margin: '0 auto', width: '100%' }}>

        {/* ── Header: student + week navigation ─────────────────── */}
        <div style={{
          background: 'linear-gradient(135deg, #5E9E3E, #4A8830)',
          color: '#fff', borderRadius: 16,
          padding: '32px 28px', boxShadow: SHADOW_MD,
          position: 'relative', overflow: 'hidden', marginBottom: 24,
          textAlign: 'center',
        }}>
          {['⭐', '✨', '🌟'].map((e, i) => (
            <div key={i} style={{
              position: 'absolute',
              top: `${10 + (i * 30) % 70}%`, left: `${6 + (i * 35) % 85}%`,
              fontSize: 26 + (i % 3) * 8, opacity: 0.15, pointerEvents: 'none',
              transform: `rotate(${i * 45}deg)`,
            }}>{e}</div>
          ))}

          <div style={{
            width: 72, height: 72, margin: '0 auto 16px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 42,
          }}>🦉</div>
          <div style={{ fontSize: 12, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.yellowSoft, letterSpacing: 3, marginBottom: 6 }}>
            📊 BÁO CÁO HỌC TẬP
          </div>
          <div style={{ fontSize: 26, fontFamily: FONT_DISPLAY, fontWeight: 600, letterSpacing: -0.5, marginBottom: 10 }}>
            Học sinh: <span style={{ color: HT.yellow }}>Minh</span>
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, opacity: 0.85, marginBottom: 18 }}>
            Level: <span style={{ fontWeight: 800 }}>Flyers ✈️</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <button style={{
              padding: '8px 16px', border: '1px solid rgba(255,255,255,0.3)', borderRadius: 999,
              background: 'rgba(255,255,255,0.12)', color: '#fff', fontFamily: FONT_BODY, fontSize: 12, fontWeight: 700,
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
            }}>← Tuần trước</button>
            <div style={{
              background: '#fff', color: HT.greenDark,
              padding: '8px 18px', borderRadius: 999,
              fontSize: 13, fontWeight: 700, boxShadow: SHADOW_SM,
            }}>Tuần 14/04 – 20/04/2026</div>
            <button style={{
              padding: '8px 16px', border: '1px solid rgba(255,255,255,0.3)', borderRadius: 999,
              background: 'rgba(255,255,255,0.12)', color: '#fff', fontFamily: FONT_BODY, fontSize: 12, fontWeight: 700,
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
            }}>Tuần sau →</button>
          </div>
        </div>

        {/* ── Weekly stats (4 cards) ─────────────────── */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: 14, marginBottom: 28,
        }}>
          {stats.map((s, i) => (
            <div key={i} style={{
              background: HT.white, border: `1px solid ${HT.border}`, borderRadius: 16,
              padding: '20px 16px', boxShadow: SHADOW_SM,
              textAlign: 'center',
            }}>
              <div style={{
                width: 52, height: 52, margin: '0 auto 10px', borderRadius: 14,
                background: s.bg,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 26,
              }}>{s.emoji}</div>
              <div style={{ fontSize: 22, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.text, letterSpacing: -0.5 }}>
                {s.value}
              </div>
              <div style={{ fontSize: 12, fontWeight: 600, color: HT.textMuted, marginTop: 2 }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* ── Strengths + Weaknesses ─────────────────── */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 18, marginBottom: 28,
        }}>
          {/* Strengths */}
          <div style={{
            background: HT.white, border: `1px solid ${HT.border}`, borderRadius: 16,
            padding: '22px 24px', boxShadow: SHADOW_SM,
            borderTop: `4px solid ${HT.teal}`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{
                width: 38, height: 38, borderRadius: 10, background: '#E8F8F5',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
              }}>✅</div>
              <div style={{ fontSize: 18, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.text }}>Điểm mạnh của con</div>
            </div>
            {strengths.map((item, i) => (
              <div key={i} style={{ marginBottom: 14, paddingBottom: 14, borderBottom: i < strengths.length - 1 ? `1px dashed ${HT.border}` : 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: HT.text }}>{item.name}</div>
                  <div style={{
                    background: '#E8F8F5', color: HT.teal,
                    borderRadius: 999,
                    padding: '2px 10px', fontSize: 12, fontWeight: 700,
                  }}>{item.score}%</div>
                </div>
                <div style={{
                  height: 6, background: HT.greenBg,
                  borderRadius: 99, overflow: 'hidden', marginBottom: 6,
                }}>
                  <div style={{
                    width: `${item.score}%`, height: '100%', background: HT.teal,
                    borderRadius: 99,
                  }} />
                </div>
                <div style={{ fontSize: 11, fontWeight: 600, color: HT.textMuted, fontStyle: 'italic', lineHeight: 1.4 }}>
                  {item.msg}
                </div>
              </div>
            ))}
          </div>

          {/* Weaknesses */}
          <div style={{
            background: HT.white, border: `1px solid ${HT.border}`, borderRadius: 16,
            padding: '22px 24px', boxShadow: SHADOW_SM,
            borderTop: `4px solid ${HT.coral}`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{
                width: 38, height: 38, borderRadius: 10, background: '#FFF0E6',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
              }}>⚠️</div>
              <div style={{ fontSize: 18, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.text }}>Cần hỗ trợ thêm</div>
            </div>
            {weaknesses.map((item, i) => (
              <div key={i} style={{
                background: HT.yellowBg, border: `1px solid ${HT.border}`, borderRadius: 12,
                padding: '12px 14px', marginBottom: 10,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: HT.text }}>{item.name}</div>
                  <div style={{
                    background: '#FFF0E6', color: HT.coralDark,
                    borderRadius: 999,
                    padding: '2px 10px', fontSize: 12, fontWeight: 700,
                  }}>{item.score}%</div>
                </div>
                <div style={{
                  height: 6, background: HT.greenBg,
                  borderRadius: 99, overflow: 'hidden', marginBottom: 8,
                }}>
                  <div style={{
                    width: `${item.score}%`, height: '100%', background: HT.coral,
                    borderRadius: 99,
                  }} />
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 14 }}>💡</span>
                  <div style={{ fontSize: 11, fontWeight: 600, color: HT.textSoft, lineHeight: 1.5 }}>
                    {item.tip}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Progress comparison ─────────────────── */}
        <div style={{
          background: HT.white, border: `1px solid ${HT.border}`, borderRadius: 16,
          padding: '22px 24px', boxShadow: SHADOW_SM,
          marginBottom: 28,
        }}>
          <div style={{ fontSize: 18, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.text, marginBottom: 18, textAlign: 'center' }}>
            📈 So sánh tiến độ
          </div>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 14,
          }}>
            {progress.map((item, i) => (
              <div key={i} style={{
                background: HT.yellowBg, border: `1px solid ${HT.border}`, borderRadius: 14,
                padding: '16px 14px', boxShadow: SHADOW_SM,
                textAlign: 'center',
              }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: HT.textMuted, marginBottom: 8 }}>
                  {item.label}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 16, color: HT.textMuted, textDecoration: 'line-through', fontWeight: 700 }}>
                    {item.prev}
                  </span>
                  <span style={{ color: HT.textMuted }}>→</span>
                  <span style={{
                    fontSize: 22, fontFamily: FONT_DISPLAY, fontWeight: 600,
                    color: item.positive ? HT.teal : HT.text,
                  }}>{item.current}</span>
                </div>
                <div style={{
                  display: 'inline-block', marginTop: 6,
                  background: item.positive ? '#E8F8F5' : '#F5F5F5',
                  color: item.positive ? HT.teal : HT.textMuted,
                  borderRadius: 999,
                  padding: '2px 10px', fontSize: 11, fontWeight: 700,
                }}>
                  {item.positive ? '▲ ' : '── '}{item.diff}
                </div>
              </div>
            ))}
          </div>
          <div style={{
            background: HT.yellowSoft, borderRadius: 12,
            padding: '10px 14px', marginTop: 16,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            fontSize: 13, fontWeight: 700, color: HT.brown,
          }}>
            🎉 Con có tiến bộ rõ rệt ở kỹ năng Nghe!
          </div>
        </div>

        {/* ── Weekly activity calendar ─────────────────── */}
        <div style={{
          background: HT.white, border: `1px solid ${HT.border}`, borderRadius: 16,
          padding: '22px 24px', boxShadow: SHADOW_SM,
          marginBottom: 28,
        }}>
          <div style={{ fontSize: 18, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.text, marginBottom: 18, display: 'flex', alignItems: 'center', gap: 8 }}>
            📅 Hoạt động trong tuần
          </div>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 8, marginBottom: 16,
          }}>
            {weekDays.map((d, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: HT.textMuted, marginBottom: 6 }}>{d.day}</div>
                <div style={{
                  width: 44, height: 44, margin: '0 auto', borderRadius: '50%',
                  background: d.active ? HT.teal : HT.yellowBg,
                  border: d.active ? 'none' : `1px solid ${HT.border}`,
                  boxShadow: d.active ? SHADOW_SM : 'none',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18, color: d.active ? '#fff' : HT.textMuted,
                }}>
                  {d.active ? '✓' : '○'}
                </div>
                {d.active ? (
                  <>
                    <div style={{ fontSize: 10, fontWeight: 700, color: HT.text, marginTop: 6 }}>{d.count}</div>
                    <div style={{ fontSize: 10, fontWeight: 600, color: HT.textMuted }}>{d.time}</div>
                  </>
                ) : (
                  <div style={{ fontSize: 10, fontWeight: 600, color: HT.textMuted, marginTop: 6 }}>Nghỉ</div>
                )}
              </div>
            ))}
          </div>
          <div style={{
            display: 'flex', justifyContent: 'center', gap: 24, paddingTop: 14,
            borderTop: `1px dashed ${HT.border}`,
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: HT.textMuted }}>Trung bình</div>
              <div style={{ fontSize: 16, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.text }}>2.4 bài/ngày</div>
            </div>
            <div style={{ width: 1, background: HT.border }} />
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: HT.textMuted }}>Thời gian học</div>
              <div style={{ fontSize: 16, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.text }}>9 phút/ngày</div>
            </div>
          </div>
        </div>

        {/* ── AI message from owl ─────────────────── */}
        <div style={{
          background: 'linear-gradient(135deg, #5E9E3E, #4A8830)',
          borderRadius: 16, color: '#fff',
          padding: '22px 24px', boxShadow: SHADOW_MD,
          marginBottom: 28, position: 'relative',
        }}>
          <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
            <div style={{
              width: 56, height: 56, borderRadius: 14, background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 32, flexShrink: 0,
            }}>🦉</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, fontFamily: FONT_DISPLAY, fontWeight: 600, color: HT.yellowSoft, letterSpacing: 2, marginBottom: 4 }}>
                LỜI NHẮN TỪ HU
              </div>
              <div style={{ fontSize: 17, fontFamily: FONT_DISPLAY, fontWeight: 600, marginBottom: 10 }}>
                Tuần này Minh học rất tốt!
              </div>
              <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.6, opacity: 0.92 }}>
                <p style={{ margin: '0 0 10px' }}>
                  Chào ba mẹ, tuần qua Minh đã có những bước tiến rất đáng khen, đặc biệt là ở kỹ năng Nghe. Con đạt tỉ lệ chính xác gần như tuyệt đối (95%) ở bài tập Matching.
                </p>
                <p style={{ margin: '0 0 10px' }}>
                  Tuy nhiên, con đang gặp chút khó khăn với thì <b>Quá khứ đơn (Past Simple)</b>. Tuần tới, Hu sẽ ưu tiên hiển thị các bài học ôn tập lại phần này dưới dạng trò chơi tương tác.
                </p>
                <p style={{ margin: 0 }}>
                  Tiếp tục duy trì streak 5 ngày để hình thành thói quen học bền vững. Chúc Minh và ba mẹ một tuần mới vui vẻ! 🎉
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ── Share actions ─────────────────── */}
        <div style={{
          background: HT.brownDark, color: '#fff',
          borderRadius: 16,
          padding: '24px 24px', boxShadow: SHADOW_MD,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 16, fontFamily: FONT_DISPLAY, fontWeight: 600, marginBottom: 16 }}>
            📤 Chia sẻ báo cáo cho gia đình
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
            <button style={{
              padding: '10px 20px', border: 'none', borderRadius: 999,
              background: '#0068FF', color: '#fff',
              fontFamily: FONT_BODY, fontSize: 13, fontWeight: 700,
              boxShadow: '0 2px 8px rgba(0,104,255,0.3)', cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 8,
            }}>📱 Gửi qua Zalo</button>
            <button style={{
              padding: '10px 20px', border: 'none', borderRadius: 999,
              background: '#fff', color: HT.text,
              fontFamily: FONT_BODY, fontSize: 13, fontWeight: 700,
              boxShadow: SHADOW_SM, cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 8,
            }}>✉️ Gửi Email</button>
            <button style={{
              padding: '10px 20px', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 999,
              background: 'rgba(255,255,255,0.1)', color: '#fff',
              fontFamily: FONT_BODY, fontSize: 13, fontWeight: 700,
              cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8,
            }}>🔗 Copy Link</button>
          </div>
          <div style={{
            display: 'inline-block',
            background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: 999, padding: '6px 16px',
            fontSize: 12, fontFamily: 'monospace', opacity: 0.8,
          }}>hupath.vn/report/abc123</div>
          <div style={{
            fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.4)',
            letterSpacing: 2, marginTop: 10,
          }}>AI CÓ LINK ĐỀU XEM ĐƯỢC — KHÔNG CẦN ĐĂNG NHẬP</div>
        </div>
      </main>
    </div>
  );
};

export default WeeklyReportPage;
